import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PublicRoute = ({ children }) => {
  const { token } = useSelector(state => state.userState);
  
  // If already authenticated, redirect to dashboard
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // If not authenticated, render the public component
  return children;
};

export default PublicRoute;